export const GET_ALL_IMAGES_ASSEMBLING = 'GET_ALL_IMAGES_ASSEMBLING';


